import { CaretLeftIcon } from '@phosphor-icons/react/dist/ssr/CaretLeft';
import * as s from './MobileWindowBackButton.css';

export interface MobileWindowBackButtonProps {
  onClick: () => void;
  /** 접근성 이름. 기본값은 「목록으로」. */
  label?: string;
}

/**
 * 모바일 테이크오버 제목줄 앞자리(`leadingSlot`)에 서는 뒤로 가기 ‹.
 *
 * 상세에서 목록으로 돌아가는 보조 동작이라 보이는 것은 20px 기호 하나로 두고, 누르는 영역만
 * 44px(WCAG 2.5.5, 닫기 버튼과 같은 기준)로 둔다. 본문 카드 안에 채움 · 테두리 · 14px 로
 * 서 있던 「목록으로」 버튼이 화면 전환 탭보다 강하게 그려지던 것을 대신한다.
 */
export function MobileWindowBackButton({
  onClick,
  label = '목록으로',
}: MobileWindowBackButtonProps) {
  return (
    <button type="button" className={s.button} onClick={onClick} aria-label={label}>
      <CaretLeftIcon className={s.icon} weight="bold" aria-hidden="true" />
    </button>
  );
}
